import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';
import classnames from 'classnames';
import Switch from '../../../inputs/switch';

class FormControlSwitch extends PureComponent {
  constructor(props) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    const { input } = this.props;
    input.onChange(!input.value);
  }

  render() {
    const {
      classNameContainer,
      classNameLabelContainer,
      id,
      input,
      label,
      meta: { touched, error },
      required,
      onLabel,
      offLabel,
    } = this.props;

    let validationState = null;
    let errorText = null;

    if (touched) {
      if (error) {
        validationState = 'danger';
        errorText = error;
      } else {
        validationState = 'success';
      }
    }

    return (
      <FormGroup
        row
        color={validationState}
        className={classnames('form-group-row', classNameContainer)}
      >
        <div className={classnames('form-group-row__label-container', classNameLabelContainer)}>
          <Label for={id} className="yes-no__label">
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
          <div className="d-flex">
            <Col className="form-group-row__col">
              <Switch
                checked={input.value}
                index={id}
                off={offLabel}
                on={onLabel}
                onChange={this.onToggle}
              />
              {errorText && <FormFeedback>{errorText}</FormFeedback>}
            </Col>
          </div>
        </div>
      </FormGroup>
    );
  }
}

FormControlSwitch.propTypes = {
  classNameContainer: PropTypes.string,
  classNameLabelContainer: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({ onChange: PropTypes.func, value: PropTypes.bool }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  meta: PropTypes.shape({}),
  offLabel: PropTypes.string,
  onLabel: PropTypes.string,
  required: PropTypes.bool,
};

export default FormControlSwitch;
